/* eslint-disable */
import { Card } from 'antd'
import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { HiOutlineArrowNarrowRight } from 'react-icons/hi'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { capitalize } from '../../../../utils'
import JobInformation from '../../JobDetails/JobInformation'
import * as s from './styles'

export default ({
  job,
  id,
  theme,
  contractType,
  createdAt,
  location,
  title,
}) => {
  const { t } = useTranslation(['careers'], {
    useSuspense: false,
  })
  const company = useSelector((state) => state.company)
  return (
    <s.JobItemWrapper theme={theme}>
      <Link to={`${company.careersPageName}/${id}`}>
        <Card border="none">
          <div className="job-item">
            <div className="job-info">
              <p className="job-title-wrapper">
                <span className="job-title">
                  {capitalize(title.toLowerCase())}
                </span>
              </p>
              <JobInformation card job={job} />
            </div>
            <div className="job-apply" style={{ fontWeight: '600' }}>
              <p>
                {t('careers:jobItem.seeDetails')}
                <HiOutlineArrowNarrowRight
                  style={{ fontSize: '16px', marginLeft: '5px' }}
                />
              </p>
              {/* <span style={{ opacity: '.5', fontSize: '12px' }}>
                {moment(createdAt).fromNow()}
              </span> */}
            </div>
          </div>
        </Card>
      </Link>
    </s.JobItemWrapper>
  )
}
